import React from 'react';
import { Container, Typography, Box, Button, Stack, Avatar } from '@mui/material';
import { BuildOutlined, BookOutlined, AccountCircleOutlined, ArticleOutlined, EmailOutlined, Article } from '@mui/icons-material';
import Header from '../components/blog/components/Header';
import Footer from '../components/blog/components/Footer';
import AppTheme from '../components/shared-theme/AppTheme';
import { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { fetchGithub, env } from '../services/AppService';
import { alpha, styled } from '@mui/material/styles';
import './HomePage.css';
import FacebookIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import IconButton from '@mui/material/IconButton';

// Convert PascalCase to snake_case.
function pascalToSnake(s)
{
	return s.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
}

const StyledButton = styled(Button)(({ theme }) => ({
	borderRadius: '20px',
}));

// Convert a GitHub API URL to a GitHub client URL.
function apiToClient(apiUrl)
{
	return apiUrl.replace('api.github.com/repos', 'github.com')
		.replace('/commits/', '/commit/');
}

function GithubActivity({ username, event, len = 3 })
{
	const snake = pascalToSnake(event)
	const [recentActivity, setRecentActivity] = React.useState([])


	React.useEffect(() => {
	  console.log(`Fetching GitHub activity for ${username}`);
	  fetchGithub(username)
	    .then(data => {
	      console.log('Fetched data:', data);
	      const activity = data.filter(e => e.type === event).slice(0, len);
	      console.log('Filtered activity:', activity);
	      setRecentActivity(activity);
	    })
	    .catch(error => {
	      console.error('Error fetching GitHub activity:', error);
	    });
	}, [username, event, len]);


	return (
		<>
		<Box>
			<Stack spacing={2}>
			<Typography variant='h6' gutterBotton>
				Recent Activity
			</Typography>
				{recentActivity.map((e, i) => (
					<StyledButton
						key={i}
						href={apiToClient(e.payload.commits[0].url)}
						target='_blank'
						variant='outlined'
						size='large'
						sx={{
							width: 450
						}}
					>
						<mycode>{`${e.repo.name} -- ${e.payload.commits[0].message}` || 'No Activity'}</mycode>
					</StyledButton>
				))}
			</Stack>
		</Box>
		</>
	);
}

//const HomeStyledButton = styled(StyledButtonBase(({ theme }) => ({
//	position: 'relative',
//	height: 200,
//	[theme.breakpoints.down('sm')]: {
//		width: '100% !important',	// Overrides inline-style
//		height: 100,
//	}
//}));

function MenuButton({ text, icon })
{
	return (
		<>
		<Button
			variant='outlined'
			startIcon={icon}
			href={`/${text}`}
			size='large'
			sx={{
				borderRadius: '30px',
			}}
		>
			<Typography
				textTransform='none'
				variant=''
				sx={{
					fontSize: '1.6em'
				}}
			>
				{`${text}/`}
			</Typography>
		</Button>
		</>
	);
}

function HomeMenu()
{
	return (
		<>
		<Box>
		<Stack
			spacing={1}
			direction='column'
			sx={{
				width: 240,
			}}
		>
			<Typography sx={{
				fontSize: '1.6em',
			}}>
				{'/home/tdbax/'}
			</Typography>
			<MenuButton text='projects' icon={<BuildOutlined/>} />
			<MenuButton text='blog' icon={<BookOutlined />} />
			<MenuButton text='about' icon={<AccountCircleOutlined />} />
			<MenuButton	text='CV' icon={<ArticleOutlined />} />
			<MenuButton text='contact' icon={<EmailOutlined />} />
		</Stack>
		</Box>
		</>
	);
}

function SetDarkMode()
{
	const { setMode } = useColorScheme();
	
	React.useEffect(() => {
	  setMode("dark"); // Force dark mode
	}, [setMode]);
	
	return null; // No UI needed, it just sets the mode
}

export default function HomePage(props)
{
	//const { setMode } = useColorScheme();
	//React.useEffect(() => {
	//	setMode('dark');
	//}, [setMode]);

	return (
		<>
		<AppTheme {...props}>
		<CssBaseline enableColorScheme />
		<Container sx={{
			textAlign: 'center',
			flexGrow: 1,
			mt: 8
		}}>
			<Typography variant='h1' gutterBottom>
				Hello, I'm tdbax
			</Typography>
			<Box mt={4}>
				<Stack
					spacing={15}
					direction='row'
					justifyContent='center'
					alignItems='center'
					useFlexGap
				>
					<Stack
						spacing={4}
						direction='column'
						justifyContent='center'
						alignItems='center'
						useFlexGap
					>
						<Avatar
							alt='Asuka Langley Soryu'
							src={`${env.DOMAIN}/static/img/asuka-profile.jpg`}
							sx={{ 
								height: '20vh',
								width: '20vh'
							}}
						/>
						{/*<GithubActivity
							username='agge3'
							event='PushEvent'
							len={4}
						/>*/}
					</Stack>
					
					<Stack spacing={3} alignItems='center'>
						<HomeMenu />
						<Stack spacing={1} direction='row'>
    						<IconButton
    						  color="inherit"
    						  size="large"
    						  href="https://github.com/agge3"
    						  aria-label="GitHub"
    						  sx={{ alignSelf: 'center' }}
    						>
    						<FacebookIcon />
							</IconButton>

    						<IconButton
    						  color="inherit"
    						  size="large"
    						  href="https://www.linkedin.com/in/baxtertyler"
    						  aria-label="LinkedIn"
    						  sx={{ alignSelf: 'center' }}
    						>
    						<LinkedInIcon />
							</IconButton>
						</Stack>
					</Stack>

				</Stack>
			</Box>
		</Container>
		<Footer />
		</AppTheme>
		</>
	);
}
